import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Israel (1-99)
import israel1 from '../images/israel1.jpeg';
import israel2 from '../images/israel2.jpeg';
import israel3 from '../images/israel3.jpeg';
import israel4 from '../images/israel4.jpeg';
import israel5 from '../images/israel5.jpeg';
import israel6 from '../images/israel6.jpeg';
import israel7 from '../images/israel7.jpeg';
import israel8 from '../images/israel8.jpeg';
import israel10 from '../images/israel10.jpeg';
import israel11 from '../images/israel11.jpeg';
import israel12 from '../images/israel12.jpeg';
import israel13 from '../images/israel13.jpeg';
import israel14 from '../images/israel14.jpeg';
import israel15 from '../images/israel15.jpeg';
import israel16 from '../images/israel16.jpeg';
import israel17 from '../images/israel17.jpeg';
import israel18 from '../images/israel18.jpeg';
import israel19 from '../images/israel19.jpeg';
import israel20 from '../images/israel20.jpeg';
import israel21 from '../images/israel21.jpeg';
import israel22 from '../images/israel22.jpeg';
import israel23 from '../images/israel23.jpeg';
import israel24 from '../images/israel24.jpeg';
import israel25 from '../images/israel25.jpeg';
import israel26 from '../images/israel26.jpeg';
import israel27 from '../images/israel27.jpeg';
import israel28 from '../images/israel28.jpeg';
import israel29 from '../images/israel29.jpeg';
import israel30 from '../images/israel30.jpeg';
import israel31 from '../images/israel31.jpeg';
import israel32 from '../images/israel32.jpeg';
import israel33 from '../images/israel33.jpeg';
import israel34 from '../images/israel34.jpeg';
import israel35 from '../images/israel35.jpeg';
import israel36 from '../images/israel36.jpeg';
import israel37 from '../images/israel37.jpeg';
import israel38 from '../images/israel38.jpeg';
import israel39 from '../images/israel39.jpeg';
import israel40 from '../images/israel40.jpeg';
import israel41 from '../images/israel41.jpeg';
import israel42 from '../images/israel42.jpeg';
import israel43 from '../images/israel43.jpeg';
import israel44 from '../images/israel44.jpeg';
import israel45 from '../images/israel45.jpeg';
import israel46 from '../images/israel46.jpeg';
import israel47 from '../images/israel47.jpeg';
import israel48 from '../images/israel48.jpeg';
import israel49 from '../images/israel49.jpeg';
import israel50 from '../images/israel50.jpeg';
import israel51 from '../images/israel51.jpeg';
import israel52 from '../images/israel52.jpeg';
import israel53 from '../images/israel53.jpeg';
import israel54 from '../images/israel54.jpeg';
import israel55 from '../images/israel55.jpeg';
import israel56 from '../images/israel56.jpeg';
import israel57 from '../images/israel57.jpeg';
import israel58 from '../images/israel58.jpeg';
import israel59 from '../images/israel59.jpeg';
import israel60 from '../images/israel60.jpeg';
import israel61 from '../images/israel61.jpeg';
import israel62 from '../images/israel62.jpeg';
import israel63 from '../images/israel63.jpeg';
import israel64 from '../images/israel64.jpeg';
import israel65 from '../images/israel65.jpeg';
import israel66 from '../images/israel66.jpeg';
import israel67 from '../images/israel67.jpeg';
import israel68 from '../images/israel68.jpeg';
import israel69 from '../images/israel69.jpeg';
import israel70 from '../images/israel70.jpeg';
import israel71 from '../images/israel71.jpeg';
import israel72 from '../images/israel72.jpeg';
import israel73 from '../images/israel73.jpeg';
import israel74 from '../images/israel74.jpeg';
import israel75 from '../images/israel75.jpeg';
import israel76 from '../images/israel76.jpeg';
import israel77 from '../images/israel77.jpeg';
import israel78 from '../images/israel78.jpeg';
import israel79 from '../images/israel79.jpeg';
import israel80 from '../images/israel80.jpeg';
import israel81 from '../images/israel81.jpeg';
import israel82 from '../images/israel82.jpeg';
import israel83 from '../images/israel83.jpeg';
import israel84 from '../images/israel84.jpeg';
import israel85 from '../images/israel85.jpeg';
import israel86 from '../images/israel86.jpeg';
import israel87 from '../images/israel87.jpeg';
import israel88 from '../images/israel88.jpeg';
import israel89 from '../images/israel89.jpeg';
import israel90 from '../images/israel90.jpeg';
import israel91 from '../images/israel91.jpeg';
import israel92 from '../images/israel92.jpeg';
import israel93 from '../images/israel93.jpeg';
import israel94 from '../images/israel94.jpeg';
import israel95 from '../images/israel95.jpeg';
import israel96 from '../images/israel96.jpeg';
import israel97 from '../images/israel97.jpeg';
import israel98 from '../images/israel98.jpeg';
import israel99 from '../images/israel99.jpeg';

function Israel() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    israel1, israel2, israel3, israel4, israel5, israel6, israel7, israel8, israel10,
    israel11, israel12, israel13, israel14, israel15, israel16, israel17, israel18, israel19, israel20,
    israel21, israel22, israel23, israel24, israel25, israel26, israel27, israel28, israel29, israel30,
    israel31, israel32, israel33, israel34, israel35, israel36, israel37, israel38, israel39, israel40,
    israel41, israel42, israel43, israel44, israel45, israel46, israel47, israel48, israel49, israel50,
    israel51, israel52, israel53, israel54, israel55, israel56, israel57, israel58, israel59, israel60,
    israel61, israel62, israel63, israel64, israel65, israel66, israel67, israel68, israel69, israel70,
    israel71, israel72, israel73, israel74, israel75, israel76, israel77, israel78, israel79, israel80,
    israel81, israel82, israel83, israel84, israel85, israel86, israel87, israel88, israel89, israel90,
    israel91, israel92, israel93, israel94, israel95, israel96, israel97, israel98
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇮🇱Israel 2023🇮🇱</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Israel ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Israel;